export const wrapper =
  'grid max-lg:grid-rows-[311px_1fr] lg:grid-cols-2 bg-[#F4E7DB] items-center justify-items-center lg:h-[492px]'
export const productColumn =
  'lg:w-3/5 max-lg:[&>*]:pl-4 max-lg:[&>div>p]:pr-4 max-lg:[&>*]:justify-items-start grid lg:items-baseline max-lg:order-2 max-lg:py-11'
export const productImage =
  'absolute h-auto object-cover max-lg:left-1/2 max-lg:top-1/3 max-lg:w-[311px] max-lg:-translate-x-1/2 max-lg:-translate-y-1/4 lg:left-[-20%] lg:top-1/2 lg:w-[435px] lg:-translate-y-1/2 lg:translate-x-[20%]'
export const productLink = 'block'
export const productContent = 'max-lg:max-w-[500px] lg:max-w-[380px]'
export const imagesColumn =
  'max-lg:h-[311px] lg:h-[492px] w-full relative max-lg:order-1'
export const productName = 'headline-h3 font-Lora uppercase mb-5'
export const subtitle = 'font-Roboto font-bold text-15 mb-5'
export const copy = 'font-Roboto font-normal text-15 mb-5'
